import {
  FlexBox,
  SPACING,
  Typography,
  QuestInstance,
  QuestRoutine,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { ROUTINE_LABEL_KEYS } from "./addEditQuestModal/questLabelKeys"
import QuestCard from "./QuestCard"
import { QuestGroupCard } from "./QuestGroupCard"
import { QuestSectionType } from "../../types/quests"
import { sortQuestSection } from "../../util/util"
import { QuestCardStatusOverlay } from "../me/CatchUpCompleteContent"

interface Props {
  title: string
  questInstances: QuestInstance[][]
  icon: string
}

const QuestRoutineSection = ({ title, questInstances, icon }: Props) => {
  const { t } = useTranslation()
  const sortedQuests = sortQuestSection(questInstances)
  const routineKey = ROUTINE_LABEL_KEYS[title as QuestRoutine]

  return (
    <FlexBox className="routine-section" gap={SPACING.space2}>
      <FlexBox
        direction="row"
        wrap={false}
        align="center"
        gap={SPACING.space1}
        justify="center"
      >
        <img style={{ height: "16px" }} src={icon} alt="icon" />
        <Typography variant="bodySmallBold">
          {routineKey ? t(routineKey) : title}
        </Typography>
      </FlexBox>
      <FlexBox direction="column" gap={SPACING.space1} align="unset">
        {sortedQuests.map((questGroup, i: number) => (
          <div style={{ position: "relative", width: "100%" }} key={i}>
            {/* @ts-ignore */}
            {questGroup.length === 1 && questGroup[0].temp_status && (
              <QuestCardStatusOverlay
                // @ts-ignore
                questStatus={questGroup[0].temp_status}
              />
            )}
            {questGroup.length === 1 ? (
              <QuestCard
                questInstance={questGroup[0]}
                type={QuestSectionType.ROUTINE}
                index={i}
              />
            ) : (
              <QuestGroupCard
                questGroup={questGroup}
                type={QuestSectionType.ROUTINE}
                index={i}
              />
            )}
          </div>
        ))}
      </FlexBox>
    </FlexBox>
  )
}
export default QuestRoutineSection
